//base url
//Local URL
//export const BASE_URL = "http://localhost:9025/tl-core";

//AWS Prod URL
export const BASE_URL = "https://api.truelift.media/tl-core";

//AWS staging URL
// export const BASE_URL = "http://stagingapi.truelift.media/tl-core";


export const FALCON_BASE_URL =
  "https://falcon-staging-bucket.s3.ap-south-1.amazonaws.com";

// login API
export const LOGIN = `${BASE_URL}/login`; 

// logout
export const LOGOUT = `${BASE_URL}/logout`;

//forgot password
export const FORGET_PASSWORD = `${BASE_URL}/forgot-password`;

// ==> User API's
// Create User
export const CREATE_USER = `${BASE_URL}/user/`;

// Update User By Id 
export const UPDATE_USER = `${BASE_URL}/user`;

// Get User Details By Id
export const GET_USER_DETAILS = `${BASE_URL}/user`;

//Users List
export const GET_USERS_LIST = `${BASE_URL}/user/list`;

// ==> Publisher API's
//Create Publisher
export const CREATE_PUBLISHER = `${BASE_URL}/publisher/`;

//Update Publisher
export const UPDATE_PUBLISHER = `${BASE_URL}/publisher`;

//Publisher Details
export const GET_PUBLISHER_DETAILS = `${BASE_URL}/publisher`;

//Publisher List
export const GET_PUBLISHER_LIST = `${BASE_URL}/publisher/list`;

//Publisher Reset Password
export const PUBLISHER_RESET_PASSWORD = `${BASE_URL}/publisher/reset-password`;

// ===> Deal API's
//Create Deal
export const CREATE_DEAL = `${BASE_URL}/deal/`;

//Update Deal By Id
export const UPDATE_DEAL = `${BASE_URL}/deal`;

//Deal Details
export const DEAL_DETAILS = `${BASE_URL}/deal`;

//Deal List
export const DEAL_LIST = `${BASE_URL}/deal/list`;

// ===> Product Type API's
// Create Product Type
export const CREATE_PRODUCT_TYPE = `${BASE_URL}/product-type/`;

//Update Product Type
export const UPDATE_PRODUCT_TYPE = `${BASE_URL}/product-type`;

// Product List
export const PRODUCT_LIST = `${BASE_URL}/product-type/list`;

// Product Type Details
export const GET_PRODUCT_TYPE_DETAILS = `${BASE_URL}/product-type`;

// Product Type Details
export const DELETE_PRODUCT_TYPE = `${BASE_URL}/product-type`;

// ===> Insertion Orders API's
// Create Insertion Order
export const CREATE_INSERTION_ORDER = `${BASE_URL}/insertion-order/`;

//Update Insertion Order
export const UPDATE_INSERTION_ORDER = `${BASE_URL}/insertion-order`;

//Insertion Order Details
export const INSERTION_ORDER_DETAILS = `${BASE_URL}/insertion-order`;

//Insertion Order List
export const INSERTION_ORDER_LIST = `${BASE_URL}/insertion-order/list`;

// Insertion Order History
export const INSERTION_ORDER_HISTORY = `${BASE_URL}/insertion-order/history`;

// Download Insertion Order
export const DOWNLOAD_INSERTION_ORDER = `${BASE_URL}/insertion-order/download`;

// Delete Order History
export const DELETE_INSERTION_ORDER = `${BASE_URL}/insertion-order`;

//Tag API's
//Create Tag
export const CREATE_TAG = `${BASE_URL}/deal-tag/`;

// Update Tag
export const UPDATE_TAG = `${BASE_URL}/deal-tag`;

// Tag Details
export const TAG_DETAILS = `${BASE_URL}/deal-tag`;

// TAg List
export const TAG_LIST = `${BASE_URL}/deal-tag/list`;

// Publisher Billing Info API's
// Create Publisher Billing Info
export const CREATE_PUBLISHER_BILLING_INFO = `${BASE_URL}/publisher-billing-info/`;

// Get Publisher Billing Info By Publisher Id
export const GET_PUBLISHER_BILLING_INFO = `${BASE_URL}/publisher-billing-info`;

// Update Publisher Billing Info By Publisher Id
export const UPDATE_PUBLISHER_BILLING_INFO = `${BASE_URL}/publisher-billing-info`;

// Update Publisher Billing Info By Publisher Id
export const VALIDATE_URL_UUID = `${BASE_URL}/validate-link`;

//Reset Password
export const RESET_PASSWORD = `${BASE_URL}/reset-password`;

//Advertiser Block List
export const ADVERTISER_BLOCK_LIST = `${BASE_URL}/advertise-blocklist-version/`;

//GET Advertiser Block List
export const GET_ADVERTISER_BLOCK_LIST = `${BASE_URL}/advertise-blocklist-version/`;

//Download Advertiser Block List
export const DOWNLOAD_ADVERTISER_BLOCK_LIST = `${BASE_URL}/advertise-blocklist-version/download/`;

//Download Advertiser Block List
export const DOWNLOAD_ADS_TXT_FILE = `${BASE_URL}/ads-txt-version/download/`;

//GET Advertiser Block List
export const ADS_FILE_UPLOAD = `${BASE_URL}/ads-txt-version/`;

//User Reset Password
export const USER_RESET_PASSWORD = `${BASE_URL}/user/reset-password`;

//GET Advertiser Block List
export const ADVERTIZE_LIST_FILE_UPLOAD = `${BASE_URL}/advertise-list-version/`;

//GET Advertiser Block List
export const GET_ADS_LIST = `${BASE_URL}/ads-txt-version/`;

//GET Advertiser Block List
export const GET_ADVERTIZE_LIST = `${BASE_URL}/advertise-list-version/`;

export const DOWNLOAD_ADVERTIZE_LIST_FILE = `${BASE_URL}/advertise-list-version/download/`;

// Margin Management API's
// Margin Management List
export const MARGIN_MANAGEMENT_LIST = `${BASE_URL}/margin-rule/`;

// Create Management List
export const CREATE_MARGIN_MANAGEMENT = `${BASE_URL}/margin-rule/`;

// Margin Management Data
export const GET_MARGIN_MANAGEMENT_DATA = `${BASE_URL}/margin-rule`;

// Update Margin Management
export const UPDATE_MARGIN_MANAGEMENT = `${BASE_URL}/margin-rule`;

//==> Dashboard API's
export const ADMIN_DASHBOARD_CHART_API = `${BASE_URL}/dashboard/analytics`;

// Admin Reporting Api
export const GET_ADMIN_REPORTING_LIST = `${BASE_URL}/reporting-raw/list`;

//upload reporting csv File
export const UPLOAD_REPORTING_CSV_FILE = `${BASE_URL}/user/import-csv`;

//csv log API
export const GET_CSV_LOG_LIST = `${BASE_URL}/user/csv-logs`;
// Admin KPI's Api
export const GET_ADMIN_KPI_DATA = `${BASE_URL}/dashboard/stats`;

// Admin Performance Api
export const GET_ADMIN_PERFORMANCE = `${BASE_URL}/dashboard/admin-performance`;

// Publisher Logs API's
export const ADVERTISER_BLOCK_LOGS_LIST = `${BASE_URL}/advertise-blocklist-version/list`;

export const ADVERTISE_LOGS_LIST = `${BASE_URL}/advertise-list-version/list`;

export const ADS_LOGS_LIST = `${BASE_URL}/ads-txt-version/list`;

// Admin Reporting Api
export const REPORTING_PROCESS = `${BASE_URL}/reporting-raw/process`;

//==> Publisher Reporting
export const GET_PUBLISHER_KPI_DATA = `${BASE_URL}/dashboard/publisher/stats`;

// Publisher Reporting Api
export const GET_PUBLISHER_REPORTING_LIST = `${BASE_URL}/reporting-raw/publisher/list`;

//export to csv functionality
export const EXPORT_CSV_FUNCTIONALITY = `${BASE_URL}/reporting-raw/list/export-csv`

//export login as publisher 
export const LOGIN_AS_PUBLISHER = `${BASE_URL}/user/login-as-publisher`

export const CHANGE_PASSWORD = `${BASE_URL}/user/change-password`

export const GET_DEMAND_PARTNER_LIST = `${BASE_URL}/demand-partner/list`

//Create Publisher User 
export const CREATE_PUBLISHER_USER = `${BASE_URL}/user/publisher-user`

// List Publisher User 
export const LIST_PUBLISHER_USER = `${BASE_URL}/user/list-publisher-users`

//Publisher User Details 
export const PUBLISHER_USER_DETAILS = `${BASE_URL}/user/publisher-user`

//Bank detail history 
export const BANK_DETAIL_HISTORY = `${BASE_URL}/publisher-billing-info/list-history`

// Get Publisher Billing Info By Publisher Id
export const LIST_PUBLISHER_BILLING_INFO = `${BASE_URL}/publisher-billing-info/list`;

//Get bank info details 
export const BANK_INFO_DETAILS = `${BASE_URL}/publisher-billing-info/details/`

// Update Publisher Billing Info By Publisher Id
export const UPDATE_PUBLISHER_BILLING_INFO_STATUS = `${BASE_URL}/publisher-billing-info/update`;

// Update Publisher Billing Info By Publisher Id
export const PUBLISHER_BILLING_STATUS = `${BASE_URL}/publisher/billing-status`;

// Update Publisher Billing Info By Publisher Id
export const LEDGER_LIST = `${BASE_URL}/publisher/ledger-list`;

// Update Publisher Billing Info By Publisher Id
export const ADD_LEDGER_ADJUSTMENT = `${BASE_URL}/ledger-adjustment/`;

// Adjustement Details
export const ADJUSTEMENT_DETAILS = `${BASE_URL}/ledger-adjustment/`

//Add Publisher Advance 
export const ADD_PUBLISHER_ADVANCE = `${BASE_URL}/publisher-advance/`

//Publisher Advance List 
export const PUBLISHER_ADVANCE_LIST = `${BASE_URL}/publisher-advance/list`

//Publisher Advance List 
export const PUBLISHER_ADVANCE_DETAILS = `${BASE_URL}/publisher-advance/`

//Country List api 
export const COUNTRY_LIST = `${BASE_URL}/country/list`

//post ledger api 
export const POST_LEDGER = `${BASE_URL}/ledger/`

//Update ledger api 
export const UPDATE_LEDGER_STATUS = `${BASE_URL}/ledger/update-status/`

//Publisher Ledger List 
export const PUBLISHER_LEDGER_LIST = `${BASE_URL}/ledger/list-publisher`

// Update Publisher Billing Info By Publisher Id
export const POSTED_LEDGER_LIST = `${BASE_URL}/publisher/posted/ledger-list`;

//Upload Invoice API
export const UPLOAD_INVOICE = `${BASE_URL}/ledger-invoice/`

//Upload Invoice API
export const LIST_INVOICES = `${BASE_URL}/ledger-invoice/list`

//GET Details of ledger 
export const GET_INVOICE_DETAILS = `${BASE_URL}/ledger-invoice/`

//Get Active ledger details
export const GET_ACTIVE_LEDGER_DETAILS = `${BASE_URL}/ledger-invoice/publisher`

//List Rerun Logs 
export const LIST_RERUN_LOGS = `${BASE_URL}/ledger/list-rerun-logs`;

//list invoice history 
export const LIST_INVOICES_HISTORY = `${BASE_URL}/ledger/list-invoice-history`

//download invoice 
export const DOWNLOAD_INVOICE = `${BASE_URL}/ledger-invoice/download-invoice`